import { useQuery } from '@tanstack/react-query';
import { getPermissions } from '../../services/permissions.service';

/**
 * Permission catalog query — read-only fetch of every permission
 * exposed by the backend (paginated to 500 in the service call).
 * The set is essentially static for an authenticated user, but we
 * still go through React Query so it participates in the global
 * invalidate-on-org-switch contract (ADR 102).
 */
export const permissionKeys = {
  all: ['permissions'] as const,
};

export interface UseAllPermissionsOptions {
  enabled?: boolean;
}

export function useAllPermissions(options?: UseAllPermissionsOptions) {
  return useQuery({
    queryKey: permissionKeys.all,
    queryFn: getPermissions,
    staleTime: 10 * 60 * 1000,
    enabled: options?.enabled ?? true,
  });
}
